import { all, takeEvery, put, call } from 'redux-saga/effects';
import { get } from 'lodash';
import Api from '../../../../../helpers/api';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import { transformEventsObjects } from './utils/utils';
import notifications from '../../../../../redux/notifications/actions';
import actions from './actions';

const api = new Api('workers/:id/calendars');

function* loadData({ payload }) {
  try {
    const { time_from, time_to, id } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { time_from, time_to }, id },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data) {
      const events = get(result, 'data.success.data.records', {});
      const convertedEvents = transformEventsObjects(events);

      yield put(actions.loadDataSuccess({ events: convertedEvents }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
